import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import InlineSVG from 'svg-inline-react';
import SVGs from 'il-framework-icons/output/il-framework-icons.svg';

var IlIconInitializer = /*#__PURE__*/function (_Component) {
  _inherits(IlIconInitializer, _Component);
  var _super = _createSuper(IlIconInitializer);
  function IlIconInitializer() {
    _classCallCheck(this, IlIconInitializer);
    return _super.apply(this, arguments);
  }
  _createClass(IlIconInitializer, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement(InlineSVG, {
        src: SVGs,
        className: "hidden"
      });
    }
  }]);
  return IlIconInitializer;
}(Component);

export { IlIconInitializer };
